import React, { useEffect, useRef } from 'react';
import { loadExternalScript } from '../../utils/scriptLoader';

const D3_URL = 'https://d3js.org/d3.v7.min.js';

function WinningLosingDonut({ segments }) {
  const chartRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    async function render() {
      if (!chartRef.current) return;
      const container = chartRef.current;
      container.innerHTML = '';

      if (!segments || segments.length === 0) {
        return;
      }

      const total = segments.reduce((sum, segment) => sum + (segment.count || 0), 0);
      if (total === 0) {
        return;
      }

      const d3 = await loadExternalScript(D3_URL, 'd3');
      if (cancelled) return;

      const cw = container.clientWidth || 400;
      const ch = container.clientHeight || cw; // default to square if no explicit height
      const width = cw;
      const height = ch;
      const radius = Math.min(width, height) / 2 - 10;

      const svg = d3
        .select(container)
        .append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMidYMid meet')
        .style('width', '100%')
        .style('height', '100%');

      const group = svg.append('g').attr('transform', `translate(${width / 2}, ${height / 2})`);

      const color = d3
        .scaleOrdinal()
        .domain(segments.map((segment) => segment.label))
        .range(segments.map((segment) => segment.color));

      const pie = d3.pie().value((d) => d.count);
      const arc = d3.arc().innerRadius(70).outerRadius(radius);
      const labelArc = d3.arc().innerRadius(radius * 0.5).outerRadius(radius * 0.8);

      const pieData = pie(segments);

      group
        .selectAll('path')
        .data(pieData)
        .join('path')
        .attr('d', arc)
        .attr('fill', (d) => color(d.data.label))
        .attr('stroke', 'white')
        .style('stroke-width', '2px');

      group
        .selectAll('text')
        .data(pieData)
        .join('text')
        .text((d) => `${d.data.label} (${d.data.count})`)
        .attr('transform', (d) => `translate(${labelArc.centroid(d)})`)
        .style('text-anchor', 'middle')
        .style('font-size', '16px')
        .style('fill', '#444');
    }

    render();

    return () => {
      cancelled = true;
    };
  }, [segments]);

  return <div ref={chartRef} />;
}

export default WinningLosingDonut;
